"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = exports.sidebarWith = void 0;
var React = __importStar(require("react"));
var createStyles_1 = __importDefault(require("@mui/styles/createStyles"));
var MobileHeader_1 = require("./MobileHeader/MobileHeader");
var classnames_1 = __importDefault(require("classnames"));
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var LayoutContext_1 = require("./LayoutContext");
exports.sidebarWith = 220;
var useStyles = (0, makeStyles_1.default)(function (t) { return (0, createStyles_1.default)({
    root: {
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
    },
    rootDesktop: {
        marginLeft: exports.sidebarWith,
    },
}); });
var Layout = function (_a) {
    var title = _a.title, mobileBreakpoint = _a.mobileBreakpoint, children = _a.children, sidebar = _a.sidebar;
    return (React.createElement(LayoutContext_1.LayoutProvider, { title: title, mobileBreakpoint: mobileBreakpoint },
        React.createElement(LayoutUsingContext, { sidebar: sidebar }, children)));
};
exports.Layout = Layout;
var LayoutUsingContext = function (_a) {
    var children = _a.children, Sidebar = _a.sidebar;
    var classes = useStyles();
    var isMobileWidth = (0, LayoutContext_1.useLayoutContext)().isMobileWidth;
    return (React.createElement(React.Fragment, null,
        React.createElement(MobileHeader_1.MobileHeader, null),
        React.createElement("div", { className: (0, classnames_1.default)(classes.root, !isMobileWidth && classes.rootDesktop) },
            Sidebar && React.createElement(Sidebar, null),
            children)));
};
//# sourceMappingURL=Layout.js.map